import React from "react";
import "../../styles/TestCasesField.css";

// Up to three test cases for a "Code to compile with output" question. The
// student app runs the student's program once per case — Input is fed line by
// line to input() / prompt() — and the answer is correct when every case
// prints its Expected output. Students see each case's input before they
// answer; the expected output is shown to them once they submit.
const MAX_CASES = 3;
const EMPTY = { input: "", expectedOutput: "" };

const TestCasesField = ({ value = [], onChange }) => {
  const cases = Array.from({ length: MAX_CASES }, (_, i) => ({ ...EMPTY, ...(value[i] || {}) }));
  const update = (idx, key, text) => {
    const next = cases.map((c, i) => (i === idx ? { ...c, [key]: text } : c));
    onChange(next);
  };

  return (
    <div className="tcf-wrapper">
      <p className="tcf-hint">
        Optional. Students&apos; code is run once per test case and marked correct only if every case prints its
        expected output. Leave Input empty for programs that take no input. With no test cases, the output is
        compared with the Answer above.
      </p>
      {cases.map((c, idx) => (
        <div className="tcf-case" key={idx}>
          <div className="tcf-case-title">Test case {idx + 1}</div>
          <div className="tcf-grid">
            <label className="tcf-field">
              <span>Input <em>one line per input()</em></span>
              <textarea
                rows={3}
                spellCheck={false}
                value={c.input}
                placeholder={"e.g.\n5\n7"}
                onChange={(e) => update(idx, "input", e.target.value)}
              />
            </label>
            <label className="tcf-field">
              <span>Expected output</span>
              <textarea
                rows={3}
                spellCheck={false}
                value={c.expectedOutput}
                placeholder="e.g. 12"
                onChange={(e) => update(idx, "expectedOutput", e.target.value)}
              />
            </label>
          </div>
        </div>
      ))}
    </div>
  );
};

// Cases with neither field filled are dropped before saving.
export const cleanTestCases = (cases = []) =>
  cases
    .map((c) => ({ input: String(c.input || ""), expectedOutput: String(c.expectedOutput || "") }))
    .filter((c) => c.input.trim() || c.expectedOutput.trim());

export default TestCasesField;
